























import { Component, Prop, Vue , Watch } from "vue-property-decorator";

@Component({
  components: {
  },
})
export default class PatternButton extends Vue {
    @Prop() private userConfigColor! : string;

    setIsSelectPatternVisible(){
        this.$emit("setIsSelectPatternVisible");
    }
}
